import { Box, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../../../features/track';

const linkCss = { color: 'text', textDecoration: 'underline', _hover: { color: 'text' } };
const trackClickProps = {
  name: 'ViewPortfolioDisclosures',
  location: 'PortfolioStrategyCard',
  flow: 'EnvelopeAccount',
};

type PortfolioDescriptionAndDisclosureProps = {
  descriptionHtml: string;
  disclosureUrl?: string | null;
};

export const PortfolioDescriptionAndDisclosure: React.FC<
  React.PropsWithChildren<PortfolioDescriptionAndDisclosureProps>
> = props => {
  const { descriptionHtml, disclosureUrl } = props;

  return (
    descriptionHtml && (
      <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box css={{ width: '100%' }}>
          <Text
            css={{ '& > a': { color: 'text', textDecoration: 'underline' } }}
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          />
          {disclosureUrl && (
            <>
              {' '}
              <SambaAutoLink to={disclosureUrl} target="_blank" css={linkCss}>
                See disclosures
              </SambaAutoLink>
            </>
          )}
        </Box>
      </Box>
    )
  );
};

type PortfolioStandaloneDisclosureProps = { disclosureUrl: string };

export const PortfolioStandaloneDisclosure: React.FC<React.PropsWithChildren<PortfolioStandaloneDisclosureProps>> = ({
  disclosureUrl,
}) => (
  <SambaAutoLink
    to={disclosureUrl}
    target="_blank"
    css={{ color: 'text', textDecoration: 'underline', _hover: { color: 'text' } }}
    onClick={() => trackClick(trackClickProps)}
  >
    See portfolio disclosures
  </SambaAutoLink>
);
